import { render } from "./Remarques.vue?vue&type=template&id=e2de484a"
import script from "./Remarques.vue?vue&type=script&lang=js"
export * from "./Remarques.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__